<script setup lang="ts">
import { locale_float } from '~/types/shared';
const { t } = useI18n()

const { userId } = defineProps<{
	userId: string
}>()

const page = ref(1)
const per_page = ref(10)
const cards = ref<any>(null)

const cardsColumns = computed(() => [
	{ label: t('data'), key: 'created_at', sortable: true },
	{ label: t('type'), key: 'slug', sortable: false },
	{ label: t('status_label'), key: 'status', sortable: false },
	{ label: t('balance'), key: 'balance', sortable: true },
	{ label: t('card_number'), key: 'label', sortable: false },
])

const fetchCards = async () => {
	const api = useApi()
	if (!userId) return

	const requestBody: any = {
		filter: { user_id: { '$oid': userId } },
		skip: (page.value - 1) * per_page.value,
		limit: per_page.value,
		sort: { created_at: -1 },
	}
	cards.value = await api.post('/api/cs/find', requestBody)
	return cards.value
}

if (!cards.value) {
	await fetchCards()
}

watch([page, per_page], () => {
	fetchCards()
})

</script>

<template>
	<div>
		<ResponsiveTable
			:rows="cards?.items"
			:columns="cardsColumns"
		>
			<template #created_at-data="{ row }">
				<DateColumn :row="row" />
			</template>
			<template #slug-data="{ row }">
				<SlugTypeColumn :row="row" :slug-type-id="row.ax_data?.templateId ?? row.hp_data?.productId" />
			</template>
			<template #status-data="{ row }">
				<CardStatusColumn :row="row" @update="fetchCards" />
			</template>
			<template #label-data="{ row }">
				<div class="text-zinc-800 dark:text-zinc-300">
					<UBadge
						:color="'gray'"
						:label="`**** ${row.label}`"
						variant="solid"
					/>
				</div>
			</template>
			<template #balance-data="{ row }">
				<div class="space-y-2 cursor-pointer">
					<div class="flex items-center space-x-2">
						<UIcon name="i-cryptocurrency-usd" class="w-5 h-5 text-violet-600"/>
						<div class="text-zinc-800 dark:text-zinc-300 font-mono text-lg">{{ locale_float(row.balance) }}</div>
					</div>
				</div>
			</template>
		</ResponsiveTable>
		<div class="flex justify-end mt-4">
			<UPagination
				v-model="page"
				:page-count="per_page"
				:total="cards?.meta?.filter_items_count || 0"
			/>
		</div>
	</div>
</template>
